import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import cx from 'classnames';
import s from './HealthRecordDate.css';


const HealthRecordDate = ({ time }) => {
  const dayName = moment(time).format('dddd'); // Tuesday
  const month = moment(time).format('MMM'); // Nov
  const dayInMonth = moment(time).format('DD'); // 18
  const year = moment(time).format('YYYY'); // 2016
  const timeOfDay = moment(time).format('h:mm A'); // 9:52 AM

  return (
    <section className={s.component}>
      <p className={s.date}>
        {dayName}&nbsp;|&nbsp;
      </p>
      <p className={cx(s.date, s.month)}>
        {month}&nbsp;{dayInMonth},
      </p>
      <p className={s.date}>
        &nbsp;{year}
      </p>
      <p className={cx(s.date, s.timeOfDay)}>
        &nbsp;{timeOfDay}
      </p>
    </section>
  );
};

HealthRecordDate.propTypes = {
  time: PropTypes.number,
};

export default HealthRecordDate;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordDate/HealthRecordDate.js